/**
 * Despatch step catalog helpers for the shop-floor kiosk (despatch-tracking
 * spec §4/§11). Mirrors
 * `modules/shopfloor_kiosk_module/models/despatch_step.py`'s
 * `DESPATCH_STEP_ORDER` exactly — one classification, both layers, same
 * "display ordering only, any order may be recorded" invariant as
 * `kioskJobMilestones.ts` mirrors the production status grouping.
 */
import type { KioskDespatchStep } from "../data/api-types";

export const DESPATCH_STEP_ORDER: readonly KioskDespatchStep[] = [
  "picked",
  "packed",
  "labelled",
  "paperwork",
  "despatched",
];

const DESPATCH_STEP_LABELS: Record<KioskDespatchStep, string> = {
  picked: "Picked",
  packed: "Packed",
  labelled: "Labelled",
  paperwork: "Paperwork",
  despatched: "Despatched",
};

export function despatchStepLabel(step: KioskDespatchStep): string {
  return DESPATCH_STEP_LABELS[step];
}
